// extracted by mini-css-extract-plugin
module.exports = {"cell":"TeamCell_cell__0_Z_F","logo":"TeamCell_logo__qVw90"};